import { useQuery, useMutation, useQueryClient } from "react-query";
import { useApiService } from "../useApiService";
import { QUERY } from "../../constants/query";
import { PropertyControllerService } from "../../services";
import { UserMessageControllerService } from "../../services";
// Hook to get a property by ID
export const useGetProperty = (propertyId: string) => {
  const { handleRequest } = useApiService();
  const queryKey = [QUERY.GET_PROPERTY, propertyId];

  const query = useQuery(
    queryKey,
    () =>
      handleRequest(
        PropertyControllerService.propertyControllerGetProperty(propertyId)
      ),
    {
      enabled: !!propertyId,
    }
  );

  return {
    ...query,
  };
};

export const useGetAllProperties = (tenantId: string) => {
  const { handleRequest } = useApiService();
  const queryKey = [QUERY.GET_ALL_PROPERTIES, tenantId];

  const query = useQuery(
    queryKey,
    () =>
      handleRequest(
        PropertyControllerService.propertyControllerGetAllProperties(tenantId)
      ),
    {
      enabled: !tenantId || !!tenantId, // Ensures query is enabled when tenantId is not defined or has a value.
    }
  );

  return {
    ...query,
  };
};

// Hook to update a property
export const useUpdateProperty = () => {
  const { handleRequest } = useApiService();
  const queryClient = useQueryClient();

  const mutation = useMutation(
    ({ propertyId, requestBody }: { propertyId: string; requestBody: any }) =>
      handleRequest(
        PropertyControllerService.propertyControllerUpdateProperty(
          propertyId,
          requestBody
        )
      ),
    {
      onSuccess: (response) => {
        console.log("Property updated successfully:", response);
        queryClient.invalidateQueries(QUERY.GET_ALL_PROPERTIES);
      },
    }
  );

  return {
    ...mutation,
  };
};

// Hook to delete a property
export const useDeleteProperty = () => {
  const { handleRequest } = useApiService();
  const queryClient = useQueryClient();

  const mutation = useMutation(
    (propertyId: string) =>
      handleRequest(
        PropertyControllerService.propertyControllerDeleteProperty(propertyId)
      ),
    {
      onSuccess: () => {
        console.log("Property deleted successfully");
        queryClient.invalidateQueries(QUERY.GET_ALL_PROPERTIES);
      },
    }
  );

  return {
    ...mutation,
  };
};

// Hook to create a property
export const useCreateProperty = () => {
  const { handleRequest } = useApiService();
  const queryClient = useQueryClient();

  const mutation = useMutation(
    ({
      requestBody,
      tenantId,
    }: {
      requestBody: {
        name: string;
        address: string;
        area: number;
        mapImageUrl?: string;
        longitude?: number;
        latitude?: number;
      };
      tenantId?: string;
    }) =>
      handleRequest(
        PropertyControllerService.propertyControllerCreateProperty(
          requestBody,
          tenantId
        )
      ),
    {
      onSuccess: (response) => {
        console.log("Property created successfully:", response);
        queryClient.invalidateQueries(QUERY.PROPERTIES_LIST);
      },
    }
  );

  return {
    ...mutation,
  };
};
export const usePostVastuHelp = () => {
  const { handleRequest } = useApiService();

  const mutation = useMutation(
    ({
      propertyId,
      formData,
    }: {
      propertyId: string;
      formData?: { message?: string; files?: Array<Blob> };
    }) =>
      handleRequest(
        UserMessageControllerService.userMessageControllerSendMessage(
          propertyId,
          formData
        )
      ),
    {
      onSuccess: (response) => {
        console.log("Vastu help posted successfully:", response);
      },
      onError: (error) => {
        console.error("Error posting Vastu help:", error);
      },
    }
  );

  return {
    ...mutation,
  };
};
